export const RECOMMENDATION_SERVICE_PDP_PRODUCT_AVAILABLE =
  'service_pdp_available'
export const RECOMMENDATION_SERVICE_PDP_PRODUCT_AVAILABLE_V1 =
  'service_pdp_available_v1'
export const RECOMMENDATION_SERVICE_PDP_PRODUCT_AVAILABLE_V2 =
  'service_pdp_available_v2'
export const RECOMMENDATION_SERVICE_PDP_PRODUCT_OUT_OF_STOCK =
  'service_pdp_unavailable'
export const RECOMMENDATION_SERVICE_PDP_RX_PRODUCT = 'service_pdp_rx'
export const RECOMMENDATION_SERVICE_INACTIVITY_MODAL =
  'service_modal_inactivity'
export const RECOMMENDATION_SERVICE_PDP_FIRST_IMPRESSION = 'service_pdp_expa'
export const RECOMMENDATION_SERVICE_ADD_TO_CART = 'service_a2c'
export const RECOMMENDATION_SERVICE_ADD_TO_CART_V1 = 'service_a2c_v1'
export const RECOMMENDATION_SERVICE_HOMEPAGE = 'service_home'
export const RECOMMENDATION_SERVICE_ACCOUNT = 'service_account'
export const RECOMMENDATION_SERVICE_CATEGORY = 'service_category'
export const RECOMMENDATION_SERVICE_CART = 'service_cart'
export const RECOMMENDATION_SERVICE_NO_RESULT_PAGE = 'service_noresultpage'
export const RECOMMENDATION_SERVICE_LP_REDPOINTS = 'service_lp_redpoints'
export const RECOMMENDATION_SERVICE_LP_DELIVERY_TRACKING =
  'service_lp_deliverytracking'

export type RecommendationServiceType =
  | typeof RECOMMENDATION_SERVICE_ACCOUNT
  | typeof RECOMMENDATION_SERVICE_ADD_TO_CART
  | typeof RECOMMENDATION_SERVICE_ADD_TO_CART_V1
  | typeof RECOMMENDATION_SERVICE_CART
  | typeof RECOMMENDATION_SERVICE_CATEGORY
  | typeof RECOMMENDATION_SERVICE_HOMEPAGE
  | typeof RECOMMENDATION_SERVICE_INACTIVITY_MODAL
  | typeof RECOMMENDATION_SERVICE_LP_DELIVERY_TRACKING
  | typeof RECOMMENDATION_SERVICE_LP_REDPOINTS
  | typeof RECOMMENDATION_SERVICE_NO_RESULT_PAGE
  | typeof RECOMMENDATION_SERVICE_PDP_FIRST_IMPRESSION
  | typeof RECOMMENDATION_SERVICE_PDP_PRODUCT_AVAILABLE
  | typeof RECOMMENDATION_SERVICE_PDP_PRODUCT_AVAILABLE_V1
  | typeof RECOMMENDATION_SERVICE_PDP_PRODUCT_AVAILABLE_V2
  | typeof RECOMMENDATION_SERVICE_PDP_PRODUCT_OUT_OF_STOCK
  | typeof RECOMMENDATION_SERVICE_PDP_RX_PRODUCT
